/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import { useLocation, useParams } from "react-router-dom";

// Components
import Form from "pages/ManageContracts/Single/Form";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";
// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { useGetContractsByMeterIdQuery } from "state/contracts/contractsApiSlice";

function SingleContract() {
  const { state } = useLocation();
  const { meterId, action, meterIdentifier, effectiveAt } = state || {};
  const { id } = useParams();

  // READ contract
  const community = useSelector(selectCurrentCommunity);
  const { contract } = useGetContractsByMeterIdQuery(
    { communityId: community.id, meterId, effectiveAt },
    {
      selectFromResult: ({ data }) => ({
        contract: data?.find((obj) => obj.id === id),
      }),
      skip: action === "new",
    }
  );

  if (action === "new") {
    return (
      <>
        <HelpFloatingButtonV2 helpScreen="contracts" />
        <Form meterIdentifier={meterIdentifier} action={action} contractId={id} meterId={meterId} />
      </>
    );
  }

  return contract ? (
    <>
      <HelpFloatingButtonV2 helpScreen="contracts" />
      <Form
        contract={contract}
        meterIdentifier={meterIdentifier}
        action={action}
        contractId={id}
        meterId={meterId}
      />
    </>
  ) : (
    <></>
  );
}

export default SingleContract;
